import { IApiError } from '@/models/apiError.model';
import { IFaqImportResponse } from '@/models/faqImportExport.model';

export const SLICE_NAME = 'faqImportExport';

export interface FaqImportExportState {
  selectedFile: File | null;
  preview: IFaqImportResponse | null;
  isPreviewing: boolean;
  isApplying: boolean;
  isExporting: boolean;
  error: IApiError | null;
}

export const initialState: FaqImportExportState = {
  selectedFile: null,
  preview: null,
  isPreviewing: false,
  isApplying: false,
  isExporting: false,
  error: null,
};
